import * as Yup from "yup";

const couponStatusOptions = () => [
  { id: 0, name: "Open" },
  { id: 1, name: "Won" },
  { id: 2, name: "Lost" },
];

const validationSchema = Yup.object().shape({
  statusId: Yup.number().required().label("Coupon Status"),
  bets: Yup.array().of(
    Yup.object().shape({
      betId: Yup.mixed().required().label("Bet ID"),
      statusId: Yup.number().required().label("Bet Status"),
    })
  ),
});

const Inputs = [
  {
    name: "couponInfo",
    label: "Coupon",
    type: "display",
    display: (values) => {
      const userName = values?.user?.nickName ?? "";
      const couponId = values?.id ?? "";
      const userPart = userName ? `User: ${userName}` : "User: -";
      const couponPart = couponId ? `Coupon #${couponId}` : "Coupon # -";
      return `<div class="d-flex flex-column gap-1"><div>${userPart}</div><div>${couponPart}</div></div>`;
    },
  },
  {
    name: "id",
    label: "Id",
    type: "hidden",
    value: "single",
    valueAttr: "id",
  },
  {
    name: "user",
    label: "User",
    type: "hidden",
    value: "single",
    valueAttr: "user",
  },
  {
    name: "statusId",
    label: "Coupon Status",
    type: "selectCustom",
    value: "single",
    valueAttr: "statusId",
    required: true,
    customOptions: couponStatusOptions,
  },
  {
    name: "bets",
    label: "Bets",
    type: "nestedArray",
    value: "multiple",
    valueAttr: "bets",
    hideAdd: true,
    transformToShow: (bets) =>
      (bets || []).map((bet) => ({
        betId:
          bet?.id ??
          bet?.betId ??
          bet?.gameID ??
          bet?.gameProviderID ??
          "",
        matchName: `${bet?.homeTeam?.name ?? ""} - ${bet?.awayTeam?.name ?? ""}`.trim(),
        statusId: bet?.statusId ?? "",
      })),
    columns: [
      {
        name: "matchName",
        label: "Match",
        type: "display",
        required: false,
      },
      {
        name: "betId",
        label: "Bet ID",
        type: "hidden",
        required: true,
      },
      {
        name: "statusId",
        label: "Status",
        type: "select",
        options: couponStatusOptions(),
        required: true,
      },
    ],
  },
];

export { Inputs, validationSchema };
